import { Component, OnInit,OnDestroy, ViewChild } from '@angular/core';
import * as $ from "jquery";
import { AvailablePlan, AvailablePlanRevenue, ConfirmPurchaseResponse1, DBInsertProps, InsuranceFlight, InsuranceRights, PurchaseResponse, TravelInsurancePassengersProperties, TravelInsurancePlanPurchaseProperties } from '../Models/TravelInsuranceProperties';
import { PassengerInfoService } from '../Services/passengerInfo.service';
import { Countries } from '../Models/Countries';
import { InsuranceService } from '../Services/insurance-service.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { DatePipe, Location } from '@angular/common';
import { PassengerProfile } from '../Models/BookingPassengerTicketIssuanceProperties';
import { saveAs } from 'file-saver';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import { DxDataGridComponent, DxDataGridModule } from 'devextreme-angular';
import { exportDataGrid } from 'devextreme/pdf_exporter';
import { AgencyMasterProperties } from '../Models/AgencyMasterProperties';
import { Canvg } from 'canvg';
import { RevenueManagementService } from '../Services/revenue-management.service';
import { InsuranceRevenueCalculateProperties, RefundRevenueCalculateProperties } from '../Models/RevenueManagementProperties';
import { MessageService } from 'primeng/api';
import { NavMenuComponent } from '../nav-menu/nav-menu.component';
import { FormsModule } from '@angular/forms';
import { DxoSelectionModule, DxoPagingModule, DxoFilterRowModule, DxiColumnModule } from 'devextreme-angular/ui/nested';
import { DxTemplateModule } from 'devextreme-angular/core';
import { NgSelectModule } from '@ng-select/ng-select';

@Component({
    selector: 'app-travel-insurance-passengers',
    templateUrl: './travel-insurance-passengers.component.html',
    styleUrls: ['./travel-insurance-passengers.component.css'],
    imports: [NavMenuComponent, FormsModule, DxDataGridModule, DxoSelectionModule, DxoPagingModule, DxoFilterRowModule, DxiColumnModule, DxTemplateModule, NgSelectModule]
})
export class TravelInsurancePassengersComponent implements OnInit, OnDestroy {

  constructor(private message: MessageService, private paxService: PassengerInfoService, private insuranceService: InsuranceService, private modelSuccess: NgbModal, private router: Router, private location: Location, private revenueService: RevenueManagementService) { }
  //bookingBaseData: any;
  selectedPlan: AvailablePlan;
  selectedPlanWithRevenue: AvailablePlanRevenue;
  reqData: any;
  ValidationChck: boolean = false;
  issuanceObj = new TravelInsurancePlanPurchaseProperties();
  obj = new TravelInsurancePassengersProperties();
  //bookingPassengerInfoProperties: TravelInsurancePassengersProperties[] =  [];
  email: string = "";
  mobile: string = "";
  today: string="";
  @ViewChild('gridContainer3') dataGrid3: DxDataGridComponent;
  ngOnInit() {
    //this.bookingBaseData = JSON.parse(localStorage.getItem('bkdata'));
    this.selectedPlanWithRevenue = JSON.parse(localStorage.getItem('selectedPlan')  || '');
    this.selectedPlan = JSON.parse(localStorage.getItem('selectedPlanWithoutRevenue')  || '');
    this.reqData = JSON.parse(localStorage.getItem('TravelInsuranceRequestObj')  || '');
    this.insuranceRight = JSON.parse(localStorage.getItem('InsuranceIssueRights')  || '');
    if (this.reqData != null && this.reqData != undefined) {

      if (this.reqData.totalInfants <= 0) {
        $(".infant_type").hide();
      }
      if (this.reqData.totalChild <= 0) {
        $(".child_type").hide();
      }
      if (this.reqData.totalAdults <= 0) {
        $(".adult_type").hide();
      }
      for (let i = 0; i < this.reqData.totalAdults; i++) {
        this.obj.passengerType = 1;
        this.issuanceObj.travelInsurancePassengersProperties.push(this.obj);
        this.obj = new TravelInsurancePassengersProperties();
      }
      for (let i = 0; i < this.reqData.totalChild; i++) {
        this.obj.passengerType = 2;
        this.issuanceObj.travelInsurancePassengersProperties.push(this.obj);
        this.obj = new TravelInsurancePassengersProperties();
      }
      for (let i = 0; i < this.reqData.totalInfants; i++) {
        this.obj.passengerType = 3;
        this.issuanceObj.travelInsurancePassengersProperties.push(this.obj);
        this.obj = new TravelInsurancePassengersProperties();
      }
    }
    this.getInsuranceRevenue();
    this.getCountries();
    const today = new Date();
    this.today = new Date(today.getFullYear() - 2, today.getMonth(), today.getDate()).toISOString().split('T')[0];
    //document.getElementsByClassName('.main_text-box.dob_input').setAttribute('max', today);
  }
  countryList: Countries[] = [];
  getCountries() {
    try {
      this.paxService.getCountries().subscribe((data) => {
        this.countryList = data;

      });
    }
    catch (e) {
      //////console.log (e);
    }
  }
  insuranceRevenueList: InsuranceRevenueCalculateProperties[] = [];
  basePremium: number = 0;
  totalTaxes: number = 0;
  totalDiscount: number = 0;
  serviceFees: number = 0;
  vat: number = 0;
  totalPremiumAmount: number = 0;
  getInsuranceRevenue() {
    this.totalTaxes = Number(this.selectedPlanWithRevenue.taxAmount);
    this.vat = Number(this.selectedPlanWithRevenue.vat);
    this.totalPremiumAmount = this.selectedPlanWithRevenue.totalPremiumAmount;
    this.serviceFees = Number(this.selectedPlanWithRevenue.serviceFeeValue) * (this.reqData.totalAdults + this.reqData.totalChild + this.reqData.totalInfants);
    this.basePremium = Number(this.selectedPlanWithRevenue.baseAmount);
    this.totalDiscount = Number(this.selectedPlanWithRevenue.discountValue) * (this.reqData.totalAdults + this.reqData.totalChild + this.reqData.totalInfants);
  }
  genderSelectonGivenTitle(i) {
    var title = document.getElementById(`titles${i}`) as HTMLSelectElement;


    if (title.value == "Mstr") {
      var gender = document.getElementById(`male${i}`) as HTMLSelectElement;
      this.issuanceObj.travelInsurancePassengersProperties[i].gender = gender.value;
    }
    else if (title.value == "Mr") {
      var gender = document.getElementById(`male${i}`) as HTMLSelectElement;
      this.issuanceObj.travelInsurancePassengersProperties[i].gender = gender.value;
    }
    else if (title.value == "Ms") {
      var gender = document.getElementById(`female${i}`) as HTMLSelectElement;
      this.issuanceObj.travelInsurancePassengersProperties[i].gender = gender.value;
    }
    else if (title.value == "Miss") {
      var gender = document.getElementById(`female${i}`) as HTMLSelectElement;
      this.issuanceObj.travelInsurancePassengersProperties[i].gender = gender.value;
    }
    else if (title.value == "Mrs") {
      var gender = document.getElementById(`female${i}`) as HTMLSelectElement;
      this.issuanceObj.travelInsurancePassengersProperties[i].gender = gender.value;
    }
  }

  emailRegex: boolean = false;
  emailverifyregex(emailvalue, i) {
    var regex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
    if (emailvalue.match(regex)) {
      document.getElementById(`messageEmailRquired${i}`).innerHTML = '';
      this.emailRegex = true;
    }
    else {
      document.getElementById(`messageEmailRquired${i}`).innerHTML = 'Please Follow The Pattern';
      setTimeout(() => { document.getElementById(`messageEmailRquired${i}`).innerHTML = ''; }, 5000);
      this.emailRegex = false;
    }
    return this.emailRegex;
  }

  agreed: boolean;
  active() {
    if (this.agreed == true) {
      $(".sendButton").css({ "pointer-events": "auto", "opacity": 1 });
    }
    else {
      $(".sendButton").css({ "pointer-events": "none", "opacity": 0.6 });
    }
  }

  toTitleCase(i, str, e) {
    if (str == undefined) {
      return
    }
    var event = e.target.id;

    var firstname = document.getElementById(`firstname${i}`) as HTMLInputElement;
    var lastname = document.getElementById(`lastname${i}`) as HTMLInputElement;
    var first = firstname.id;
    var last = lastname.id;
    if (event == first) {
      var capitalizefirstname = str.replace(
        /\w\S*/g,
        function (txt) {
          return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        }

      );

      this.issuanceObj.travelInsurancePassengersProperties[i].firstName = capitalizefirstname;
    }
    if (event == last) {
      var capitalizelastname = str.replace(
        /\w\S*/g,
        function (txt) {
          return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        }

      );

      this.issuanceObj.travelInsurancePassengersProperties[i].lastName = capitalizelastname;
    }

  }
  purchaseObj: ConfirmPurchaseResponse1 = new ConfirmPurchaseResponse1();
  issuanceloader: boolean = false;
  PNR: string = "";
  successHeading: string = "";
  dbObj: DBInsertProps = new DBInsertProps();
  buttonagreed = false;
  insuranceRight = new InsuranceRights();

  IssuanceSubmit(success, failure) {
    if (!this.insuranceRight.issue) {
      this.message.add({ severity: 'error', summary: 'Rejected', detail: 'You have no Right to Issue!' });

      return;
    }
    
    this.issuanceloader = true;
    this.buttonagreed = true;
    this.issuanceObj.email = this.email;
    this.issuanceObj.mobile = this.mobile;
    this.issuanceObj.contactPerson = this.issuanceObj.travelInsurancePassengersProperties[0].firstName + " " + this.issuanceObj.travelInsurancePassengersProperties[0].lastName;
    this.issuanceObj.countryCode = this.reqData.countryCode;
    this.issuanceObj.currency = this.selectedPlan.currencyCode;
    this.issuanceObj.pnr = this.PNR;
    this.issuanceObj.purchaseDate = this.reqData.departDateTime;
    this.issuanceObj.ssrFeeCode = this.selectedPlan.ssrFeeCode;
    this.issuanceObj.totalAdults = this.reqData.totalAdults;
    this.issuanceObj.totalChild = this.reqData.totalChild;
    this.issuanceObj.totalInfants = this.reqData.totalInfants;
    this.issuanceObj.totalPremium = this.selectedPlan.totalPremiumAmount;
    this.issuanceObj.flights = [];
    if (this.reqData.requestType == "oneway") {
      for (let a = 0; a < 1; a++) {
        let flight = new InsuranceFlight();
        flight.departCountryCode = this.reqData.departCountryCode;
        flight.arrivalCountryCode = this.reqData.arrivalCountryCode;
        flight.departDatetime = this.reqData.departDateTime;
        flight.departAirlineCode = this.reqData.departAirlineCode;
        this.issuanceObj.flights.push(flight);
      }
    } else {
      for (let b = 0; b < 2; b++) {
        if (b==0) {
          let flight = new InsuranceFlight();
          flight.departCountryCode = this.reqData.departCountryCode;
          flight.arrivalCountryCode = this.reqData.arrivalCountryCode;
          flight.departDatetime = this.reqData.departDateTime;
          flight.departAirlineCode = this.reqData.departAirlineCode;
          this.issuanceObj.flights.push(flight);
        }
        if (b == 1) {
          let flight = new InsuranceFlight();
          flight.departCountryCode = this.reqData.arrivalCountryCode;
          flight.arrivalCountryCode = this.reqData.departCountryCode;
          flight.departDatetime = this.reqData.returnDateTime;
          flight.departAirlineCode = this.reqData.departAirlineCode;
          this.issuanceObj.flights.push(flight);
        }
      }
    }
    for (let q = 0; q < this.issuanceObj.travelInsurancePassengersProperties.length; q++) {
      this.issuanceObj.travelInsurancePassengersProperties[q].identityType = "Passport";
      this.issuanceObj.travelInsurancePassengersProperties[q].isQualified = true;
      this.issuanceObj.travelInsurancePassengersProperties[q].selectedPlanCode = this.selectedPlan.planCode;
      this.issuanceObj.travelInsurancePassengersProperties[q].currencyCode = this.selectedPlan.currencyCode;
      this.issuanceObj.travelInsurancePassengersProperties[q].selectedSSRFeeCode = this.selectedPlan.ssrFeeCode;
      this.issuanceObj.travelInsurancePassengersProperties[q].passengerPremiumAmount = this.selectedPlan.totalPremiumAmount / (this.issuanceObj.totalAdults + this.issuanceObj.totalChild);
      if (this.issuanceObj.travelInsurancePassengersProperties[q].passengerType == 1) {
        this.issuanceObj.travelInsurancePassengersProperties[q].isInfant = "0";
      }
      else if (this.issuanceObj.travelInsurancePassengersProperties[q].passengerType == 2) {
        this.issuanceObj.travelInsurancePassengersProperties[q].isInfant = "0";
      }
      else {
        this.issuanceObj.travelInsurancePassengersProperties[q].isInfant = "1";
        this.issuanceObj.travelInsurancePassengersProperties[q].passengerPremiumAmount = 0;
      }
    }
    this.insuranceService.ConfirmPlanPurchase(this.issuanceObj).subscribe(data => {
      this.purchaseObj.PurchaseResponse = new PurchaseResponse();
      this.purchaseObj = data;
      this.purchaseObj.PurchaseResponse.PremiumAmount = this.selectedPlan.currencyCode + this.selectedPlan.totalPremiumAmount.toString();
      this.purchaseObj.PurchaseResponse.PlanTitle = this.selectedPlan.planTitle;
      this.purchaseObj.PurchaseResponse.PolicyPurchasedFlyDate = this.issuanceObj.purchaseDate.toString();
      this.purchaseObj.PurchaseResponse.CreationUser = Number(localStorage.getItem('UserId'));
      this.purchaseObj.PurchaseResponse.IssuanceAgency = (localStorage.getItem('AgencyId'));
      this.purchaseObj.PurchaseResponse.PNR = this.issuanceObj.pnr;
      this.issuanceloader = false;
      if (this.purchaseObj.PurchaseResponse.ProposalState == 1 || this.purchaseObj.PurchaseResponse.ProposalState == "CONFIRMED") {
        //this.dbObj.requestObj = new TravelInsurancePlanPurchaseProperties();
        //this.dbObj.responseObj = new ConfirmPurchaseResponse1();
        this.issuanceloader = true;
        this.dbObj.responseObj = this.purchaseObj;
        this.dbObj.requestObj = this.issuanceObj;
        this.dbObj.plan = this.selectedPlanWithRevenue;
      //};
        this.insuranceService.InsertInsuranceIssuance(this.dbObj).subscribe((res) => {
          this.issuanceloader = false;
          if (res) {
            this.successHeading = "Plan Confirmed Successfully!";
            this.modelSuccess.open(success, {
              backdrop: 'static',
              size: 'lg',
              centered: true
            })
          }
          else {
            this.successHeading = "Plan Confirmed Successfully but Database Error Occured";
            this.modelSuccess.open(success, {
              backdrop: 'static',
              size: 'lg',
              centered: true
            })
          }
        });
      } else {
        this.modelSuccess.open(failure, {
          backdrop: 'static',
          size: 'lg',
          centered: true
        })
      }
    });
  }
  ctc_num: string = "";
  validatepass: boolean = true;
  searchprofileCred: PassengerProfile[];
  getSearchonfocusout(targetmodel, ctc, i) {
    this.ctc_num = ctc;
    var ctc_number = { ctcno: this.ctc_num }
    if (this.MobileNumberValidateWhenSearch(i) == false) {
      return;
    }
    try {

      this.paxService.GetPassengerProfileSearch(ctc_number).subscribe((data) => {

        let Searchpassenger = [];
        /* this.searchprofileCred = data;*/

        Searchpassenger = data;
        for (let i = 0; i < Searchpassenger.length; i++) {
          if (Searchpassenger[i].passengerType == 1) {
            Searchpassenger[i].passengerTypeName = "Adult";
          }
          else if (Searchpassenger[i].passengerType == 2) {
            Searchpassenger[i].passengerTypeName = "Child";
          }
          else if (Searchpassenger[i].passengerType == 3) {
            Searchpassenger[i].passengerTypeName = "Infant";
          }
        }
        this.searchprofileCred = Searchpassenger;
        for (let j = 0; j < this.searchprofileCred.length; j++) {
          this.searchprofileCred[j].passengerindex = i;
        }

        if (this.searchprofileCred.length > 0) {
          this.modelSuccess.open(targetmodel, {

            /*   windowClass: "searchpassengerpopupmodal"*/
            //scrollable: true,
            size: 'lg',
          })
        }


      });
    }
    catch (e) {
      //////console.log (e);
    }

  }
  MobileNumberValidateWhenSearch(i) {

    var mobile = document.getElementById(`mobile${i}`) as HTMLInputElement;

    /* var pattern = "@^(\+\d{1,2})?\(?\d{3}\)?\d{3}\d{4}$@";*/
    var pattern = /^\+\d{3}?\d+$/;
    if (mobile.value.match(pattern)) {

      document.getElementById(`messagepass${i}`).innerHTML = '';
      this.validatepass = true;
    }
    else {

      document.getElementById(`messagepass${i}`).innerHTML = 'Please Follow the Pattern of Mobile Number';
      this.validatepass = false;
    }
    return this.validatepass;
  }
  SearchCtcNo(targetmodel, ctc, i) {
    this.ctc_num = ctc;
    var ctc_number = { ctcno: this.ctc_num }
    if (this.MobileNumberValidateWhenSearch(i) == false) {
      return;
    }
    try {
      this.paxService.GetPassengerProfileSearch(ctc_number).subscribe((data) => {
        let Searchpassenger = [];
        /* this.searchprofileCred = data;*/
        Searchpassenger = data;
        for (let i = 0; i < Searchpassenger.length; i++) {
          if (Searchpassenger[i].passengerType == 1) {
            Searchpassenger[i].passengerTypeName = "Adult";
          }
          else if (Searchpassenger[i].passengerType == 2) {
            Searchpassenger[i].passengerTypeName = "Child";
          }
          else if (Searchpassenger[i].passengerType == 3) {
            Searchpassenger[i].passengerTypeName = "Infant";
          }
        }
        this.searchprofileCred = Searchpassenger;
        for (let j = 0; j < this.searchprofileCred.length; j++) {
          this.searchprofileCred[j].passengerindex = i;
        }
        ////////console.log (this.searchprofileCred.passengerindex);
        if (this.searchprofileCred.length > 0) {
          this.modelSuccess.open(targetmodel, {

            /*          windowClass: "searchpassengerpopupmodal"*/
            //scrollable: true,
            //size: 'modal-xl',
            size: 'lg',
          })
        }

        ////////console.log (data);

      });
    }
    catch (e) {
      //////console.log (e);
    }

  }

  Select_Profiledata(data, targetmodel) {
    try {
      var index = this.searchprofileCred[0].passengerindex;
      for (let i = 0; i < this.issuanceObj.travelInsurancePassengersProperties.length; i++) {
        if (index == i) {
          this.issuanceObj.travelInsurancePassengersProperties[i].profile_Id = data.profile_Id;
          this.issuanceObj.travelInsurancePassengersProperties[i].title = data.title;
          this.issuanceObj.travelInsurancePassengersProperties[i].firstName = data.firstName;
          this.issuanceObj.travelInsurancePassengersProperties[i].lastName = data.lastName;
          this.issuanceObj.travelInsurancePassengersProperties[i].gender = data.paxGender;
          this.issuanceObj.travelInsurancePassengersProperties[i].dateOfBirth = data.paxDOB;
          this.mobile = data.mobile_No;
          /* this.bookingObj.bookingPassengerInfoProperties[i].phone = data.phone_No,*/
          this.issuanceObj.travelInsurancePassengersProperties[i].nationality = data.paxNationality;
            /* this.bookingObj.bookingPassengerInfoProperties[i].passportValidFrom= data.passportValidFrom,*/
          this.issuanceObj.travelInsurancePassengersProperties[i].passportNumber = data.passportNumber;
          this.issuanceObj.travelInsurancePassengersProperties[i].nationality = data.countryOfIssuance;
          this.email = data.email_Id;
          this.modelSuccess.dismissAll(targetmodel);
        }
      }
    }

    catch (e) { //////console.log (e);
    }
  }

  

  goBackToResults() {
    this.location.back();
  }
  modaldismiss() {
    this.modelSuccess.dismissAll();
    this.router.navigateByUrl('zeusBookedPolicy');
  }
  ngOnDestroy() {
    //localStorage.removeItem('TravelInsuranceRequestObj');
    localStorage.removeItem('selectedPlan');
    localStorage.removeItem('bkdata');
  }
}
